<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row px-4 flex gap-4 items-end" style="align-items: center">
          <div class="flex justify-end items-center gap-4" style="flex: 1">
            <vs-button @click="downloadFile()" style="min-width: 180px" class="bg_purple float-right"
              v-has-permission="permission301">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("DownloadExcelFile") }}
            </vs-button>
          </div>
          <div class="flex">
            <div class="w-full">
              <vs-button @click="showFilters = !showFilters" class="bg_purple float-right">
                <div class="px-3">
                  <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" class="ico" />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
        </div>
        <div class="vx-row px-2 flex gap-y-4 items-end pt-4 flex-warp" v-if="showFilters">
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{ $t("Segment") }}</label>
            <v-select label="name" name="segment" :options="allSegment" :reduce="(x) => x.id" v-model="model.segmentIds"
              multiple dir="rtl">
            </v-select>
          </div>

          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{ $t("GenericProduct") }}</label>
            <v-select label="name" name="GenericProduct" :options="allGenericProducts" :reduce="(x) => x.id"
              v-model="model.GenericProductIds" multiple dir="rtl">
            </v-select>
          </div>

          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{ $t("Brand") }}</label>
            <v-select label="name" name="brand" :options="allBrands" :reduce="(x) => x.id" v-model="model.brandsId"
              multiple dir="rtl">
            </v-select>
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <vs-input v-model="model.name" @keyup.enter="submitFilter()" placeholder="نام کالا /  گارانتی / رنگ"
              :label="$t('StockName')" />
          </div>
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <vs-input v-model="model.itemCode" :label="$t('ItemCode')" @keyup.enter="submitFilter()" />
          </div>

          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{
              $t("BalanceStatus")
            }}</label>
            <v-select label="name" :options="stockBalanceOptions" v-model="model.stockBalanceFilter"
              :reduce="(x) => x.id" :clearable="false" ref="agentType" dir="rtl">
            </v-select>
          </div>
          <div class="flex gap-4 px-2 flex-grow justify-end">
            <vs-button type="filled" class="float-right" color="#3ec9d6" @click.prevent="resetForm">{{ $t("ResetFilter")
            }}</vs-button>
            <vs-button type="filled" class="float-right" @click.prevent="submitFilter">{{ $t("SubmitFilter")
            }}</vs-button>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid :showSum="false" v-has-permission="permission239" ref="grid" stripe hasModel :body="model"
              :data-source="gridDataSource" :columns="[
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },

                {
                  title: $t('LogicalBalance'),
                  sort: 'logicalBalance',
                  total: 'sumOfLogicalBalance',
                },
                {
                  title: $t('PhysicalBalance'),
                  sort: 'physicalBalance',
                  total: 'sumOfPhysicalBalance',
                },
                {
                  title: $t('CostOfGoodsPurchased'),
                  sort: 'CostOfGoodsPurchased',
                },
                {
                  title: $t('SumCostOfGoodsPurchased'),
                  sort: 'SumCostOfGoodsPurchased',
                  total: 'totalSumOfCostOfGoodsPurchased',

                },
                { title: $t('Action') },
              ]">
              <template slot-scope="{ row }">
                <td style="width: 30%" :title="row.stockName">
                  {{ row.stockName }}
                </td>
                <td style="width: 18%">
                  {{ row.itemCode }}
                </td>

                <td style="width: 10%">
                  {{ row.logicalBalance }}
                </td>
                <td style="width: 10%">
                  {{ row.physicalBalance }}
                </td>
                <td style="width: 10%">
                  {{
                    row.costOfGoodsPurchased
                      ? Number(row.costOfGoodsPurchased).toLocaleString() + " ریال"
                      : 0
                  }}
                </td>
                <td style="width: 10%">
                  {{
                    row.sumOfCostOfGoodsPurchased
                      ? Number(row.sumOfCostOfGoodsPurchased).toLocaleString() + " ریال"
                      : 0
                  }}
                </td>
                <td style="width: 15%; min-width: 185px">
                  <span>
                    <vs-button color="primary" type="border" icon-pack="feather" icon="icon-eye"
                      class="custom-border-btn" v-has-permission="'GetAllSerialsInfoInTotalStore'"
                      @click="viewSerials(row.itemCode)">{{ $t("ViewSerials") }}</vs-button>
                  </span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <serials-list-partial-popup :show="SerialsListPopup" @finish="closeSerialsListPopup"
      :popupService="popupService"></serials-list-partial-popup>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import utils from "@/assets/utils/index";
import { mapGetters, mapActions } from "vuex";
import SerialsListPartialPopup from "../CheckOutTransactions/SerialsListPartialPopup.vue";

export default {
  name: "warehouseManagement_Balance_AllWarehouses",
  components: {
    DataGrid,
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    SerialsListPartialPopup,
  },
  data() {
    return {
      showFilters: false,
      permission239: "GetAllInventoriesStocksBalances",
      permission301: "GetAllInventoriesStocksBalancesByExcelFile",
      gridDataSource: {
        type: "app",
        method: "post",
        service: "Inventory/api/StockQuery/inventories-stocks-balances",
      },

      SerialsListPopup: false,
      popupService: "",
      model: {
        stockBalanceFilter: 1,
        segmentIds: [],
        GenericProductIds: [],
      },
      allSegment: [],
      stockBalanceOptions: [
        { name: "همه", id: 0 },
        { name: "موجود", id: 1 },
        { name: "ناموجود", id: 2 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list",
    }),
  },
  mounted() {
    this.showListAllBrands();
    this.showListOfSegment();
    this.showListAllGenericProducts();
  },
  methods: {
    ...mapActions({
      exportAllWarehousesExcel: "excel/exportAllWarehousesExcel",
      fetchWarehouses: "warehouse/fetchList",
      showListAllBrands: "brand/fetchNoSkip",
      showListAllSegment: "warehouse/fetchSegment",
      showListAllGenericProducts: "genericProduct/fetchNoSkip",
    }),

    showListOfSegment() {
      this.showListAllSegment().then((result) => {
        this.allSegment = result;
      });
    },

    downloadFile() {
      // var params = utils.toQueryString(this.gridSearchData);
      this.exportAllWarehousesExcel(this.model);
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    viewSerials(itemCode) {
      let url =
        "/Inventory/api/InventoryTransactionsQuery/serial-info-in-total-store-for/" +
        itemCode;
      this.popupService = url;
      this.SerialsListPopup = true;
    },
    closeSerialsListPopup() {
      this.SerialsListPopup = false;
    },
    onfinish() {
      this.closeSerialsListPopup();
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.model = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
